import styled from 'styled-components';
import { Flex, Tabs, TabsListProps, TabsTabProps, Text, TextProps, FlexProps } from '@mantine/core';
import { PropsWithChildren, type ComponentProps } from 'react';
import { asPlainComponent } from '@dealstack/frontend/shared/utils/asPlainComponent';

const PlainText = asPlainComponent<ComponentProps<typeof Text>>(Text);

export const StyledTabText = styled(PlainText)<PropsWithChildren<TextProps>>`
	white-space: nowrap;
	font-variation-settings: 'wght' 400;
	transition: font-variation-settings 0.15s ease-out;

	// Necessary to avoid content shift when switching to bold font weight
	&::before {
		content: attr(data-label);
		font-weight: 600;
		font-variation-settings: 'wght' 600;
		height: 0;
		visibility: hidden;
		overflow: hidden;
		user-select: none;
		pointer-events: none;
		display: block;
	}
`;

export const StyledTab = styled(Tabs.Tab)<TabsTabProps>`
	justify-content: flex-start;
	border: 1px solid transparent;

	&[data-active='true'],
	&[data-active='true']:hover {
		border-color: ${({ theme }) => theme.v3.colors.blue[6]};
		color: ${({ theme }) => theme.v3.colors.dark[4]};

		${StyledTabText} {
			font-weight: 600;
			font-variation-settings: 'wght' 600;
		}
	}
`;

export const StyledTabsList = styled(Tabs.List)<
	TabsListProps & { $skipTabsBorder?: boolean; $skipTabsPadding?: boolean }
>`
	flex: 1;
	flex-wrap: nowrap;
	overflow-x: auto;

	${({ $skipTabsPadding }) => ($skipTabsPadding ? '' : `padding: 0.5rem;`)};

	${({ $skipTabsBorder, theme }) =>
		$skipTabsBorder
			? ''
			: `border: 1px solid ${theme.v3.colors.gray[4]};
			border-bottom: none;
	border-top-left-radius: 0.25rem;
	border-top-right-radius: 0.25rem;`}

	::-webkit-scrollbar {
		width: 0;
		height: 0;
	}
`;

export const StyledPanelsContainer = styled(Flex)<FlexProps & { $skipPanelsBorder?: boolean }>`
	${({ $skipPanelsBorder, theme }) =>
		$skipPanelsBorder
			? ''
			: `border: 1px solid ${theme.v3.colors.gray[4]};
	border-bottom-left-radius: 0.25rem;
	border-bottom-right-radius: 0.25rem;`}
	overflow: auto;
	flex: 1;
`;
